import { CodeShareMetadata } from "types";
import { sandboxApi } from "services/sandbox-api/api";
import { SandboxTile, SandboxTileSkeleton } from "components/elements";
import { Text } from "@itwin/itwinui-react";
import { useState } from "react";

interface TemplateListProps {
  onSelected: (template: CodeShareMetadata) => void;
}

export const TemplateList = ({ onSelected }: TemplateListProps) => {
  const [templateSelected, setTemplateSelected] = useState<CodeShareMetadata>();
  const { data, isLoading } = sandboxApi.useCodeSharesTemplatesQuery();

  const onClick = (template: CodeShareMetadata) => {
    setTemplateSelected(template);
    onSelected(template);
  };

  const templates = data
    ? data.map((template) => <SandboxTile key={template.id} sandbox={template} isSelected={template.id === templateSelected?.id} onClick={onClick} showStats={false} showUserName={false} />)
    : <><SandboxTileSkeleton /></>

  return (
    <>
      {!isLoading && data && !data.length && <Text isMuted>No sandbox templates found</Text>}
      {templates}
    </>
  )
}